import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTabGroup, MatTab, MatTabLabel } from "@angular/material/tabs";
import { DateTime } from "luxon";
import { environment } from "../../environments/environment";
import { AbstractBuyerComponent } from "./abstract/buyer.component";
import { Pair } from "../obj/Pair";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { BuyOffer } from "../entity/BuyOffer";
import { ConfirmationDialog } from "./incs/confirmation-dialog.component";
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table'
import { animate, state, style, transition, trigger } from "@angular/animations";
import { HeaderComponent } from "./incs/header.component";
import { AccountsListingComponent } from "./incs/accounts-listing.component";
import { BuyOfferEditComponent } from "./incs/buy-offer-edit.component";
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
    selector: "kilowant-buy-order-list",
    templateUrl: "../../html/main-buy-order-list.html",
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, MatTabGroup, MatTab, MatTabLabel, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, AccountsListingComponent, BuyOfferEditComponent, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CurrencyPipe, DatePipe]
})
export class BuyOfferListComponent extends AbstractBuyerComponent {

    @ViewChild("tabs") tabGroup: MatTabGroup = null!;
    dialogRef: MatDialogRef<ConfirmationDialog> = null!;
    buyOffers: BuyOffer[] = null!;
    closedBuyOffers: BuyOffer[] = null!;
    addOrderMode: boolean = false;
    editOrderMode: boolean = false;
    id: number = -1;
    pending = true;
    open = true;
    close = true;
    isShow:boolean;
    viewBuyOfferAccounts: boolean[] = [];
    viewClosedBuyOfferAccounts: boolean[] = [];
	currentStart: number = 0;
	displayedColumns: string[] = ["id", "TargetPrice", "ServiceStart", "ServiceEnd","ValidUntil"];
	tabIndex: number = 0;
	
    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.generalService.getBuyOffers(true)
            .then(buyOffers => {
                this.buyOffers = buyOffers;
                for(var i=0; i<this.buyOffers.length; i++) {
                   this.viewBuyOfferAccounts.push(false);
                }                
            });

        this.generalService.getBuyOffers(false)
            .then(closedBuyOffers => {
               this.closedBuyOffers = closedBuyOffers;
               for(var i=0; i<this.closedBuyOffers.length; i++) {
                  this.viewClosedBuyOfferAccounts.push(false);
               }                
            });
        this.addOrderMode = true;
    }


    ngAfterViewInit(): void {
        this.route.params.forEach((params: Params) => {
            let id: string = params["id"];
            if (Number(id)>0) {
               this.tabGroup.selectedIndex = 0;
               this.id=Number(id);
               this.editOrderMode = true;
            }
        }); 
    }

    editBuyOffer(buyOffer: BuyOffer): void {
            this.id=buyOffer.id;
            this.editOrderMode = true;
    }
    
    deleteBuyOffer(buyOffer: BuyOffer): void {
      this.dialogRef = this.dialog.open(ConfirmationDialog, {
         disableClose: false
          , panelClass: "i-icon-popup"
      });
      this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete this buyer offer?"

      this.dialogRef.afterClosed().subscribe(result => {
        if(result) {
          this.generalService.deleteBuyOffer(buyOffer.id)
              .subscribe((res:any) => {
                   if (res) {
                      const index = this.buyOffers.indexOf(buyOffer);
                      if (index > -1) {
                         this.buyOffers.splice(index, 1);
						 this.buyOffers = [...this.buyOffers];
                      }
                      const indexClosed = this.closedBuyOffers.indexOf(buyOffer);
                      if (indexClosed > -1) {
                         this.closedBuyOffers.splice(indexClosed, 1);
						 this.closedBuyOffers = [...this.closedBuyOffers];
                      }
                   }
               },
               err => {
               });       
        }
        this.dialogRef = null!;
       });
    }

    addBuyOffer(): void {       
         this.router.navigate(["/buy-offer/add"]);
    }

    finish(isAdd: boolean): void {
        if (isAdd) {
           this.addOrderMode = false;
        } else {
           this.generalService.getBuyOffers(true)
               .then(buyOffers => this.buyOffers = buyOffers);
		   this.buyOffers = [...this.buyOffers];
           this.editOrderMode = false;
        }
    }

    cancel(): void {
      this.addOrderMode = false;
      this.editOrderMode = false;
    }
	
	sortDataEvent(sort: Sort)
	{
		this.sortData(sort.active, sort.direction);
	}
	
	sortData(currentSortField: string, currentSortDirection: string) 
	{
		switch(this.tabIndex)
		{
			case 0:
				this.buyOffers = [...this.sortOfferData(this.buyOffers, currentSortField, currentSortDirection)];
				break;
			case 1: 
				this.closedBuyOffers = [...this.sortOfferData(this.closedBuyOffers, currentSortField, currentSortDirection)];
				break;
		}				
	}
	
	tabChanged(tabChangeEvent: MatTabChangeEvent): void 
	{
		this.id = -1;
		this.tabIndex = tabChangeEvent.index;

		this.sortData('serviceName' , 'asc');
	}
	
	sortOfferData(offers: BuyOffer[], currentSortField: string, currentSortDirection: string)
	{
		var sortedData =offers.sort((a, b) => 
		{	
			const isAsc = currentSortDirection === 'asc';  
			
			switch (currentSortField) 
			{  
				case 'TargetPrice':
					return this.compare(a.price, b.price, isAsc);  
					break; 
				
				case 'ServiceStart':
					return this.compare(a.termFrom, b.termFrom, isAsc);  
					break;			
				
				case 'ServiceEnd': 
					return this.compare(this.getTermTo(a.termFrom, a.termPeriod) , this.getTermTo(b.termFrom, b.termPeriod), isAsc);  
					break;
				
				case 'ValidUntil': 
					return this.compare(a.validDate, b.validDate, isAsc);  
					break;
					
				default: 
					return 0;
					break; 
			}

		});

		return sortedData;
	}
  	
	viewOfferInfo(buyOffer: BuyOffer): void {
		if(this.id == buyOffer.id)
		 {
			 this.id = -1;
			 this.editOrderMode = false;
		 }
		 else
		 {
			this.id = buyOffer.id;
		 }
	}
	
	compare(a: number | string | Date, b: number | string| Date, isAsc: boolean) 
	{  
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);  
	}  
}